import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/**
 * Compact SR/DE flag toggle. Uses tiny inline SVG flags for cross-platform consistency.
 */
export default function LanguageSwitcher({ className }) {
  const { lang, setLang } = useT();
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-lg border border-[#272A35] bg-[#131620] p-1",
        className,
      )}
      data-testid="lang-switcher"
      role="group"
      aria-label="Language"
    >
      <FlagBtn
        code="sr"
        active={lang === "sr"}
        onClick={() => setLang("sr")}
        label="Srpski"
      />
      <FlagBtn
        code="de"
        active={lang === "de"}
        onClick={() => setLang("de")}
        label="Deutsch"
      />
    </div>
  );
}

const FlagBtn = ({ code, active, onClick, label }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    className={cn(
      "flex items-center gap-1.5 px-2 h-7 rounded-md text-xs font-medium transition-colors",
      active
        ? "bg-[#272A35] text-white shadow-[inset_0_0_0_1px_rgba(212,175,55,0.35)]"
        : "text-slate-400 hover:text-slate-200 hover:bg-[#1A1E2C]",
    )}
    data-testid={`lang-${code}`}
  >
    {code === "sr" ? <FlagSR /> : <FlagDE />}
    <span className="uppercase font-mono-terminal tracking-wider">{code}</span>
  </button>
);

// Simple Serbian tricolor (red / blue / white) — 3 horizontal stripes.
const FlagSR = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true">
    <rect width="18" height="4" y="0" fill="#C6363C" />
    <rect width="18" height="4" y="4" fill="#0C4076" />
    <rect width="18" height="4" y="8" fill="#F5F5F5" />
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="11"
      fill="none"
      stroke="rgba(0,0,0,0.35)"
      strokeWidth="0.5"
    />
  </svg>
);

// German flag: black / red / gold horizontal stripes.
const FlagDE = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true">
    <rect width="18" height="4" y="0" fill="#111111" />
    <rect width="18" height="4" y="4" fill="#D0000F" />
    <rect width="18" height="4" y="8" fill="#FFCE00" />
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="11"
      fill="none"
      stroke="rgba(0,0,0,0.35)"
      strokeWidth="0.5"
    />
  </svg>
);
